var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    fillRule: "evenodd",
    d: "M20 7h66c5.51915024 0 10 4.48084976 10 10v66c0 5.51915024-4.48084976 10-10 10H20c-5.51915024 0-10-4.48084976-10-10V17c0-5.51915024 4.48084976-10 10-10z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-2",
    width: "200%",
    height: "200%",
    x: "-50%",
    y: "-50%",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 8,
    in: "SourceAlpha",
    result: "shadow-1-feOffset-shadow"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadow-1-feOffset-shadow",
    result: "shadow-1-feGaussianBlur-shadow",
    stdDeviation: 9.036
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadow-1-feGaussianBlur-shadow",
    result: "shadow-1-feColorMatrix-shadow",
    type: "matrix",
    values: "0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.12 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    stroke: "black",
    strokeOpacity: 0,
    strokeWidth: 0,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "rgb(64,149,144)",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    fillRule: "evenodd",
    d: "M32.15127563 38.63183594c-.862854.8515625-.87121582 2.23339843-.0083313 3.09179687.4272461.43017578.99508668.64013672 1.57125855.64013672.55947876 0 1.12731934-.21142578 1.55456543-.63330078.86288452-.85009766.87124634-2.22509766.01531982-3.0834961-.86288452-.85986328-2.26296997-.85986328-3.1328125-.01513671zm28.08566285 7.00390625c0 3.609375 2.97512817 6.54589843 6.631073 6.54589843 3.65701293 0 6.63217163-2.93652343 6.63217163-6.54589843 0-3.60839844-2.9751587-6.54492188-6.63217164-6.54492188-3.65594482 0-6.631073 2.93652344-6.631073 6.54492188zm-21.45407105-.4584961c-.862854.8515625-.87121582 2.23339844-.0083313 3.09179688.4272461.43017578.99508667.64013672 1.57125855.64013672.55947876 0 1.12731933-.21142578 1.55456543-.63330078.86288452-.85009766.87124634-2.22509766.01531982-3.0834961-.86288452-.85986328-2.26296997-.85986328-3.1328125-.01513672zm4.41275025 9.63720704c-.86288453-.85839844-.8545227-2.24023438.0083313-3.09179688.86984252-.84472656 2.26992797-.84472656 3.1328125.01513672.8559265.85839844.8475647 2.23339844-.01531983 3.0834961-.4272461.421875-.99508667.63330077-1.55456543.63330077-.57617187 0-1.14401245-.20996093-1.57125854-.64013671zm11.06103515-3.09179688c-.862854.8515625-.87121582 2.23339844-.0083313 3.09179688.4272461.43017578.99508667.64013671 1.57125855.64013671.55947876 0 1.12731933-.21142578 1.55456543-.63330078.86288452-.85009765.87124634-2.22509765.01531982-3.0834961-.86288452-.85986327-2.26296997-.85986327-3.1328125-.01513671zm-6.63995361 9.63720703c-.86288452-.85839844-.8545227-2.24023437.0083313-3.09179687.86984253-.84472657 2.26992798-.84472657 3.1328125.01513671.85592651.85839844.8475647 2.23339844-.01531983 3.0834961C50.3152771 61.78857422 49.74743652 62 49.18795776 62c-.57617187 0-1.14401245-.20996094-1.57125854-.64013672z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/icon5.851fcbf5cd2f8dd0dd5bd3d3bde652b9.svg";
export { ForwardRef as ReactComponent };